import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { OverlayContainer, FullscreenOverlayContainer, ScrollStrategyOptions } from "@angular/cdk/overlay";
import { LoaderInterceptorService } from "./@theme/components/auth/services/loader.intercepter";
import { LoaderComponent } from "./loader/vta.loader.component";
import { StartupService } from "./@theme/components/auth/services/startup.service";
import { NgxMaskDirective, provideEnvironmentNgxMask } from "ngx-mask";
import { BnNgIdleService } from "bn-ng-idle";
import { TermsAndConditionsComponent } from "./terms-and-conditions/vta.terms-and-conditions.component";
import { PrivacyPolicyComponent } from "./privacy-policy/vta.privacy-policy.component";
import { HomeModule } from "./pages/home/vta.home.module";

export function startupServiceFactory(
  startupService: StartupService
): Function {
  return () => startupService.load();
}

const maskConfigFunction: () => Partial<any> = () => {
  return {
    validation: false,
  };
};

@NgModule({ declarations: [
        AppComponent,
        LoaderComponent,
        TermsAndConditionsComponent,
        PrivacyPolicyComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatDialogModule,
        MatSnackBarModule,
        HomeModule,
        CoreModule.forRoot(),
        ThemeModule.forRoot(),
        NgxMaskDirective], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptorService,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: startupServiceFactory,
            deps: [StartupService],
            multi: true,
        },
        BnNgIdleService,
        provideEnvironmentNgxMask(maskConfigFunction),
        { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
        { provide: ScrollStrategyOptions, useClass: ScrollStrategyOptions },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
